import { useAppSelector } from '@hooks/app/redux';
import useMyWorkspaces from '@hooks/query/provider/useMyWorkspaces';
import { EditOutlined } from '@icon';
import { actions } from '@store/ducks/e-visits';
import { Button, StatusBox } from '@ui';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CalendarEdit from '../components/calendar-edit';
import CalendarView from '../components/calendar-view';
import EVisitExtra from '../components/e-visit-extra';
import { CalendarCol, EmptySC, EVisitsContent, EVisitsSC } from './e-visits.styled';

const EVisits: React.FunctionComponent = () => {
  const { push } = useHistory();
  const dispatch = useDispatch();

  const { data: myWorkspaces } = useMyWorkspaces({ hasEVisits: null });

  const user = useAppSelector((state) => state.users.currentUser!);
  const selectedInstitution = useAppSelector((state) => state.eVisits.selectedInstitution);
  const selectedDate = useAppSelector((state) => state.eVisits.selectedDate);

  const setSelectedDate = useCallback(
    (value: Date) => {
      console.log(' value', value);
      dispatch(actions.setSelectedDate(value));
    },
    [dispatch],
  );

  const [editEVisit, setEditEVisit] = React.useState(false);

  const toggleEvisitEdit = React.useCallback((visible?: boolean) => {
    setEditEVisit((o) => (visible !== undefined ? visible : !o));
  }, []);

  return (
    <>
      <EVisitsSC
        extra={
          <EVisitExtra
            canEdit={!editEVisit}
            toggleEvisitEdit={toggleEvisitEdit}
            isEditing={editEVisit}
          />
        }
      >
        {myWorkspaces && myWorkspaces.length > 0 ? (
          <EVisitsContent>
            <CalendarCol>
              <div className="calendar">
                {editEVisit ? (
                  <CalendarEdit
                    selectedInstitution={selectedInstitution}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                  />
                ) : (
                  <CalendarView
                    selectedInstitution={selectedInstitution}
                    userId={user.id}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    canAddEvent={selectedInstitution?.hasEvisit ?? false}
                  />
                )}
              </div>
            </CalendarCol>
          </EVisitsContent>
        ) : (
          <EmptySC>
            <StatusBox
              title="Žiadne pracoviská s e-Termínmi"
              description={
                <>
                  Pridajte sa pod nejaké pracovisko vo Vašom <b>Biznis profile</b> cez možnosť{' '}
                  <br />
                  <b>Upraviť zamestnancov</b>, a aktivujte si <b>e-Termín</b> funkcionalitu.
                </>
              }
              type="info"
            />
            <Button
              variant="primary"
              onClick={() => push('/business/profile/departments')}
              block={false}
              Icon={EditOutlined}
              style={{ marginTop: 16 }}
            >
              Upraviť pracoviská
            </Button>
          </EmptySC>
        )}
      </EVisitsSC>
    </>
  );
};

export default React.memo(EVisits);
